










































import Calender from '@/views/atoms/Calender.vue'
import moment from 'moment'
import BlueButton from '@/views/atoms/BlueButton.vue'
import CheckBox from '@/views/atoms/CheckBox.vue'
import Global from '@/common/global.js'
import store from '@/store'
import PopupComfirmDelete from '@/views/template/PopupComfirmDelete.vue'
import TwoCalender from '@/views/atoms/TwoCalender.vue'
import PopupReserve from '@/views/template/PopupReserve.vue'
import ApiClient from '@/common/api'
import PopupComplete from '@/views/template/PopupComplete.vue'
import PopupNotReserve from '@/views/template/PopupNotReserve.vue'

export default
  components: {
    Calender
    BlueButton
    CheckBox
    PopupComfirmDelete
    TwoCalender
    PopupReserve
    PopupComplete
    PopupNotReserve
  }

  data: () ->
    fillingList: []
    capacityList: Global.capacity()
    cancel: true
    month: moment().format('yyyy/MM/DD')
    containerType: '1'
    capacity: '3'
    id: ''
    desired_supply_date: ''
    isShowPopup: {}
    status: Global.status()
    events: []
    reserveDate: ''
    start: moment().startOf('month').format('yyyy-MM-DD')
    end: moment().add('months', 1).endOf('month').format('yyyy-MM-DD')
    detailStatus: ''
    disabled: false
    complete: ''

  created: () ->
    store.dispatch('initPostParam')
    store.dispatch('setErrors', [])
    @getEvents(@start, @end)
    @getReserveList()

  methods: {
    returnCapacity: (num) ->
      for row, index in @capacityList
        if row.id == num
          return row.name
      return ''
    detail_click: (id, date) ->
      @desired_supply_date = date
      api = new ApiClient()
      data = await api.get('/user/reserve/detail/' + id, null, null, true)
      @capacity = String(data.detail.capacity)
      @containerType = String(data.detail.container_type)
      @reserveDate =  data.detail.desired_supply_date
      @id = String(data.detail.id)
      @detailStatus = data.detail.status
      store.dispatch('setDetailParam', data)
      @showPopup('reserve')
    save_click: () ->
      @disabled = true
      postParam = store.getters.getPostParam
      if @id == ''
        param =
          name: postParam.name
          desired_supply_date: @reserveDate
          container_type: postParam.container_type
          capacity: postParam.capacity
          remarks: postParam.remarks
        @complete = '予約'
      else
        param =
          id: @id
          name: postParam.name
          desired_supply_date: postParam.desired_supply_date
          container_type: postParam.container_type
          capacity: postParam.capacity
          remarks: postParam.remarks
        @complete = '変更'
      api = new ApiClient()
      data = await api.post('/user/reserve/save', param, true, true)
      if data.errors.length == 0
        @showPopup('complete')
        store.dispatch('initPostParam')
        @getReserveList()
        @getEvents(@start, @end)
        @closePopup('reserve')
      @disabled = false
    cancel_click: (id) ->
      @id = id
    reserveDelete: () ->
      param = 
        id: @id
      api = new ApiClient()
      data = await api.post('/user/reserve/delete', param, true, true)
      @getReserveList()
      @getEvents(@start, @end)
      @closePopup('delete')
      @complete = 'キャンセル'
      @showPopup('complete')
    showPopup: (property) ->
      @$set(@isShowPopup, property, true)
    closePopup: (property) ->
      @$set(@isShowPopup, property, false)
    returnStatus: (num) ->
      for row, index in @status
        if row.id == num
          return row.name
      return ''
    status_color: (num) ->
      if num == 0
        return false
      return true
    clickDate: (date, bool) ->
      @detailStatus = ''
      store.dispatch('initPostParam')
      if bool && moment(date.date).isAfter(@month, 'day')
        @id = ''
        @containerType = '1'
        @capacity = '3'
        @reserveDate = date.date
        @showPopup('reserve')
      else
        @showPopup('notReserve')
    getReserveList: () ->
      api = new ApiClient()
      data = await api.get('/user/reserve/list', null, null, true)
      @fillingList = data.list
    monthSwitching: (v) ->
      @getEvents(v.start, v.end)
    getEvents: (start, end) ->
      @start = start
      @end = end
      param =
        start: start
        end: end
      api = new ApiClient()
      data = await api.post('/user/event', param, true, true)
      @events = data.list
    displayDay: (day) ->
      return moment(day).format('MM/DD')
  }
